<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  qualityRating: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['edit', 'delete', 'viewReport', 'resume', 'pause', 'restart']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleViewReport = campaign => emit('viewReport', campaign);
const handleResume = campaign => emit('resume', campaign);
const handlePause = campaign => emit('pause', campaign);
const handleRestart = campaign => emit('restart', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :sending-start-time="campaign.sending_start_time"
      :sending-end-time="campaign.sending_end_time"
      :pause-reason="campaign.pause_reason"
      :is-live-chat-type="isLiveChatType"
      :sent-count="campaign.sent_count || 0"
      :failed-count="campaign.failed_count || 0"
      :total-contacts="campaign.total_contacts || 0"
      :audience-names="campaign.audience_names || []"
      :conversations-with-replies="campaign.conversations_with_replies || 0"
      :quality-rating="qualityRating"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @view-report="handleViewReport(campaign)"
      @resume="handleResume(campaign)"
      @pause="handlePause(campaign)"
      @restart="handleRestart(campaign)"
    />
  </div>
</template>
